// extracted by mini-css-extract-plugin
export default {"social-media":"BaseSocialMedia_social-media__UzXZc","social-media__item":"BaseSocialMedia_social-media__item__JcD0t"};